export function generateBrokerJSON(brokersData) {
  const now = new Date();
  const formattedDate = `${now.getFullYear()}-${String(
    now.getMonth() + 1,
  ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

  const payload = {
    generatedAt: now.toISOString(),
    totalBrokers: brokersData.length,
    brokers: brokersData.map((broker) => ({
      id: broker.id,
      name: broker.name,
      cnpj: broker.cnpj,
      email: broker.email,
      banklist: broker.banklist || [],
      active: broker.active,
      createdAt: broker.createdAt,
    })),
  };

  const blob = new Blob([JSON.stringify(payload, null, 2)], {
    type: "application/json",
  });

  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `brokers_${formattedDate}.json`;
  a.click();

  URL.revokeObjectURL(a.href);
}
